import { HeroSection } from 'components/heroSection';

export const LandingScreen = () => {
	return (
		<HeroSection />
	);
};
